import { Injectable } from "@angular/core";

@Injectable()
export class EnumFilterService {
  public createEnumFilterArray<EnumType, FilterType>(enumType: EnumType, fieldName: string, omitValues: any[] = null): FilterType[] {
    const arr:  FilterType[] = [];
    for(const enumMember in enumType) {
      if (enumMember && isNaN(+enumMember)) {
        if (omitValues?.find(v => v === enumMember)) {
          continue;
        }
        const obj: any = {};
        obj[fieldName] = enumMember;
        arr.push(obj);
      }
    }
    return arr;
  }
}
